// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Matrix Question Styles */
.matrix-question {
  margin: 1rem 0;
}

.matrix-table {
  overflow-x: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.matrix-table table {
  width: 100%;
  border-collapse: collapse;
  min-width: 500px;
}

.matrix-table th,
.matrix-table td {
  padding: 12px 8px;
  text-align: center;
  border: 1px solid #e5e7eb;
}

.matrix-row-header {
  background: #f8fafc;
  font-weight: 600;
  min-width: 150px;
}

.matrix-column-header {
  background: #f3f4f6;
  font-weight: 500;
  font-size: 0.875rem;
}

.matrix-row-label {
  background: #fafbfc;
  font-weight: 500;
  text-align: left;
  padding-left: 16px;
}

.matrix-cell {
  background: white;
}

.matrix-radio,
.matrix-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #667eea;
  cursor: pointer;
}

.matrix-select {
  width: 100%;
  max-width: 120px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 0.875rem;
}

/* Star Rating Question Styles */
.star-rating-question {
  margin: 1rem 0;
  text-align: center;
}

.star-rating-container {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-bottom: 12px;
}

.star {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0.3;
  transform: scale(1);
}

.star:hover:not(.disabled) {
  transform: scale(1.1);
}

.star.active {
  opacity: 1;
  filter: drop-shadow(0 2px 4px rgba(255, 193, 7, 0.3));
}

.star.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.star-rating-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 8px;
}

.rating-label-center {
  font-weight: 600;
  color: #374151;
}

.clear-rating {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 0.8rem;
  cursor: pointer;
  text-decoration: underline;
}

.clear-rating:hover {
  color: #dc2626;
}

/* Ranking Question Styles */
.ranking-question {
  margin: 1rem 0;
}

.ranking-instructions {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  font-size: 0.875rem;
  color: #0c4a6e;
}

.ranking-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.ranked-items h4,
.unranked-items h4 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}

.ranking-list,
.unranked-list {
  min-height: 200px;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 12px;
}

.empty-ranking-area {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-style: italic;
  border: 2px dashed #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
}

.ranking-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: grab;
  transition: all 0.2s ease;
}

.ranking-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.ranking-item.dragging {
  opacity: 0.5;
  transform: rotate(5deg);
}

.ranking-item.ranked {
  border-left: 4px solid #10b981;
}

.ranking-item.unranked {
  border-left: 4px solid #6b7280;
}

.rank-number {
  background: #10b981;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  margin-right: 12px;
  flex-shrink: 0;
}

.item-text {
  flex: 1 1;
  font-weight: 500;
}

.drag-handle {
  color: #9ca3af;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  font-size: 1.2rem;
  line-height: 1;
}

.ranking-controls {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 8px;
}

.rank-button {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #374151;
  width: 24px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.rank-button:hover:not(:disabled) {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.rank-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* File Upload Question Styles */
.file-upload-question {
  margin: 1rem 0;
}

.file-drop-zone {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafbfc;
}

.file-drop-zone:hover:not(.disabled) {
  border-color: #667eea;
  background: #f8f9ff;
}

.file-drop-zone.drag-over {
  border-color: #667eea;
  background: #e0e7ff;
  transform: scale(1.02);
}

.file-drop-zone.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f3f4f6;
}

.drop-zone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.drop-zone-icon {
  font-size: 3rem;
  opacity: 0.7;
}

.drop-zone-text p {
  margin: 0;
  color: #374151;
}

.drop-zone-text p:first-child {
  font-size: 1.1rem;
  margin-bottom: 8px;
}

.file-restrictions {
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.4;
}

.file-input-hidden {
  display: none;
}

.uploaded-files {
  margin-top: 24px;
  border-top: 1px solid #e5e7eb;
  padding-top: 16px;
}

.uploaded-files h4 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.uploaded-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.uploaded-file-item:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.file-icon {
  font-size: 1.5rem;
}

.file-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-name {
  font-weight: 500;
  color: #374151;
  word-break: break-word;
}

.file-size {
  font-size: 0.875rem;
  color: #6b7280;
}

.remove-file-btn {
  background: #fee2e2;
  border: 1px solid #fecaca;
  color: #dc2626;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.remove-file-btn:hover:not(:disabled) {
  background: #fecaca;
  border-color: #f87171;
}

.remove-file-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ranking-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .matrix-table {
    font-size: 0.875rem;
  }
  
  .matrix-table th,
  .matrix-table td {
    padding: 8px 4px;
  }
  
  .star {
    font-size: 1.8rem;
  }
  
  .drop-zone-content {
    padding: 16px;
  }
  
  .drop-zone-icon {
    font-size: 2.5rem;
  }
}

/* Error Styles */
.error {
  color: #dc2626;
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 12px;
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/components/QuestionTypes/QuestionTypes.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Matrix Question Styles */\n.matrix-question {\n  margin: 1rem 0;\n}\n\n.matrix-table {\n  overflow-x: auto;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.matrix-table table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 500px;\n}\n\n.matrix-table th,\n.matrix-table td {\n  padding: 12px 8px;\n  text-align: center;\n  border: 1px solid #e5e7eb;\n}\n\n.matrix-row-header {\n  background: #f8fafc;\n  font-weight: 600;\n  min-width: 150px;\n}\n\n.matrix-column-header {\n  background: #f3f4f6;\n  font-weight: 500;\n  font-size: 0.875rem;\n}\n\n.matrix-row-label {\n  background: #fafbfc;\n  font-weight: 500;\n  text-align: left;\n  padding-left: 16px;\n}\n\n.matrix-cell {\n  background: white;\n}\n\n.matrix-radio,\n.matrix-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #667eea;\n  cursor: pointer;\n}\n\n.matrix-select {\n  width: 100%;\n  max-width: 120px;\n  padding: 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 0.875rem;\n}\n\n/* Star Rating Question Styles */\n.star-rating-question {\n  margin: 1rem 0;\n  text-align: center;\n}\n\n.star-rating-container {\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.star {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  opacity: 0.3;\n  transform: scale(1);\n}\n\n.star:hover:not(.disabled) {\n  transform: scale(1.1);\n}\n\n.star.active {\n  opacity: 1;\n  filter: drop-shadow(0 2px 4px rgba(255, 193, 7, 0.3));\n}\n\n.star.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.star-rating-labels {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 8px;\n}\n\n.rating-label-center {\n  font-weight: 600;\n  color: #374151;\n}\n\n.clear-rating {\n  background: none;\n  border: none;\n  color: #ef4444;\n  font-size: 0.8rem;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.clear-rating:hover {\n  color: #dc2626;\n}\n\n/* Ranking Question Styles */\n.ranking-question {\n  margin: 1rem 0;\n}\n\n.ranking-instructions {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n  font-size: 0.875rem;\n  color: #0c4a6e;\n}\n\n.ranking-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.ranked-items h4,\n.unranked-items h4 {\n  margin: 0 0 12px 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.ranking-list,\n.unranked-list {\n  min-height: 200px;\n  border: 2px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.empty-ranking-area {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  font-style: italic;\n  border: 2px dashed #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n}\n\n.ranking-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  margin-bottom: 8px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  cursor: grab;\n  transition: all 0.2s ease;\n}\n\n.ranking-item:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transform: translateY(-1px);\n}\n\n.ranking-item.dragging {\n  opacity: 0.5;\n  transform: rotate(5deg);\n}\n\n.ranking-item.ranked {\n  border-left: 4px solid #10b981;\n}\n\n.ranking-item.unranked {\n  border-left: 4px solid #6b7280;\n}\n\n.rank-number {\n  background: #10b981;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.item-text {\n  flex: 1;\n  font-weight: 500;\n}\n\n.drag-handle {\n  color: #9ca3af;\n  cursor: grab;\n  user-select: none;\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.ranking-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-left: 8px;\n}\n\n.rank-button {\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  color: #374151;\n  width: 24px;\n  height: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.rank-button:hover:not(:disabled) {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.rank-button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* File Upload Question Styles */\n.file-upload-question {\n  margin: 1rem 0;\n}\n\n.file-drop-zone {\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 32px 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: #fafbfc;\n}\n\n.file-drop-zone:hover:not(.disabled) {\n  border-color: #667eea;\n  background: #f8f9ff;\n}\n\n.file-drop-zone.drag-over {\n  border-color: #667eea;\n  background: #e0e7ff;\n  transform: scale(1.02);\n}\n\n.file-drop-zone.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #f3f4f6;\n}\n\n.drop-zone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.drop-zone-icon {\n  font-size: 3rem;\n  opacity: 0.7;\n}\n\n.drop-zone-text p {\n  margin: 0;\n  color: #374151;\n}\n\n.drop-zone-text p:first-child {\n  font-size: 1.1rem;\n  margin-bottom: 8px;\n}\n\n.file-restrictions {\n  font-size: 0.875rem;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.file-input-hidden {\n  display: none;\n}\n\n.uploaded-files {\n  margin-top: 24px;\n  border-top: 1px solid #e5e7eb;\n  padding-top: 16px;\n}\n\n.uploaded-files h4 {\n  margin: 0 0 12px 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.file-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.uploaded-file-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.uploaded-file-item:hover {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.file-icon {\n  font-size: 1.5rem;\n}\n\n.file-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.file-name {\n  font-weight: 500;\n  color: #374151;\n  word-break: break-word;\n}\n\n.file-size {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.remove-file-btn {\n  background: #fee2e2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.remove-file-btn:hover:not(:disabled) {\n  background: #fecaca;\n  border-color: #f87171;\n}\n\n.remove-file-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .ranking-container {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .matrix-table {\n    font-size: 0.875rem;\n  }\n  \n  .matrix-table th,\n  .matrix-table td {\n    padding: 8px 4px;\n  }\n  \n  .star {\n    font-size: 1.8rem;\n  }\n  \n  .drop-zone-content {\n    padding: 16px;\n  }\n  \n  .drop-zone-icon {\n    font-size: 2.5rem;\n  }\n}\n\n/* Error Styles */\n.error {\n  color: #dc2626;\n  background: #fee2e2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  padding: 12px;\n  font-size: 0.875rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
